import { render, staticRenderFns } from "./BooleanRadioGroup.vue?vue&type=template&id=4ce39f58&"
import script from "./BooleanRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./BooleanRadioGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports